// extracted by mini-css-extract-plugin
export default {"EffectsBlock":"EffectsBlock_EffectsBlock__6vXWq","flexColumn":"EffectsBlock_flexColumn__Nr+Lj"};